<script setup lang="ts" generic="T extends Record<string, any>">
import TreeItem from "./TreeItem.vue";
import Between from "./Between.vue";
import type { MoveEventPayload } from "./types";

withDefaults(
  defineProps<{
    data: T[];
    groups?: string[];
    expandable?: boolean;
    parentId: number | null;
    disable?: boolean;
  }>(),
  {
    groups: () => ["tree"],
    expandable: true,
  }
);

defineSlots<{
  default: (props: { item: T; expanded: boolean }) => any;
}>();

const emit = defineEmits<{
  (e: "move", value: MoveEventPayload): void;
}>();
</script>

<template>
  <div class="ps-2">
    <Between
      :at="0"
      :level-list="data"
      :parent-id="parentId"
      :groups="groups"
      @move="emit('move', $event)"
      :disable="disable"
    />
    <TreeItem
      v-for="(child, index) in data"
      :key="String(child.id)"
      :data="child"
      :source="data"
      :index="index"
      :groups="groups"
      :expandable="expandable"
      :parent-id="parentId"
      @move="emit('move', $event)"
      :disable="disable"
    >
      <template #default="{ item, expanded }">
        <slot :item="item" :expanded="expanded" />
      </template>
    </TreeItem>
  </div>
</template>

<style scoped></style>
